import React from "react";
import {
  CATEGORYCARD,
  HBNEXT_ORG_ID,
  LOGIN_ORG_ID,
  ORG_ID,
  SEFETY_HBN_CLIENT_PARTNER_PRI,
  SW_HBN_CLIENT_PARTNER_PRI,
} from "../../../../constant/constant";
import Card from "../../../../library/custom/cardList/card";
import { Grid } from "@mui/material";
import {
  checkPrivileges,
  hasAllPrivileges,
  showRighSideMenu,
} from "../../../../utils/rolesHelper";

const Utilitydashboard = ({ onClick }) => {
  const showMenu = showRighSideMenu();

  const isShowClient =
    parseInt(ORG_ID()) === parseInt(HBNEXT_ORG_ID) && checkPrivileges([12]);
  const showSafety =
    showMenu?.isSafety &&
    (isShowClient || hasAllPrivileges(SEFETY_HBN_CLIENT_PARTNER_PRI));
  const showSW =
    showMenu?.isSW &&
    (isShowClient || hasAllPrivileges(SW_HBN_CLIENT_PARTNER_PRI));
  return (
    <>
      <Grid container className="CardListContaner">
        {showMenu?.isSafety &&
          checkPrivileges([12, 1, 2]) && ( //incident
            <Card
              iconShow={false}
              onClick={onClick}
              imgShow={true}
              cardDetail={CATEGORYCARD[0]}
            />
          )}
        {checkPrivileges([12, 11, 90]) && ( //lms
          <Card
            iconShow={false}
            onClick={onClick}
            imgShow={true}
            cardDetail={CATEGORYCARD[1]}
          />
        )}
        {checkPrivileges([12, 73, 74]) && ( // resource
          <Card
            iconShow={false}
            onClick={onClick}
            imgShow={true}
            cardDetail={CATEGORYCARD[2]}
          />
        )}
        {checkPrivileges([12, 7]) && (
          <Card
            iconShow={false}
            onClick={onClick}
            imgShow={true}
            cardDetail={CATEGORYCARD[3]}
          />
        )}
        {checkPrivileges([12, 64, 43, 44, 78, 52]) && (
          <Card
            iconShow={false}
            onClick={onClick}
            imgShow={true}
            cardDetail={CATEGORYCARD[4]}
          />
        )}
        {checkPrivileges([12, 13]) && (
          <Card
            iconShow={false}
            onClick={onClick}
            imgShow={true}
            cardDetail={CATEGORYCARD[5]}
          />
        )}
        {showMenu?.isSafety && checkPrivileges([12, 37]) && (
          <Card
            iconShow={false}
            onClick={onClick}
            imgShow={true}
            cardDetail={CATEGORYCARD[6]}
          />
        )}
        {showMenu?.isSafety && checkPrivileges([12, 13]) && (
          <Card
            iconShow={false}
            onClick={onClick}
            imgShow={true}
            cardDetail={CATEGORYCARD[7]}
          />
        )}
        {showMenu?.isSW && checkPrivileges([12, 126]) && (
          <Card
            iconShow={false}
            onClick={onClick}
            imgShow={true}
            cardDetail={CATEGORYCARD[8]}
          />
        )}
        {showMenu?.isSW &&
          LOGIN_ORG_ID() == 1 &&
          checkPrivileges([12, 126]) && (
            <Card
              iconShow={false}
              onClick={onClick}
              imgShow={true}
              cardDetail={CATEGORYCARD[9]}
            />
          )}

        {(showSafety || showSW) && ( //lms mapping
          <Card
            iconShow={false}
            onClick={onClick}
            imgShow={true}
            cardDetail={CATEGORYCARD[10]}
          />
        )}

        {showSafety &&
          LOGIN_ORG_ID() == 1 &&
          checkPrivileges([12]) && ( //OSha Token
            <Card
              iconShow={false}
              onClick={onClick}
              imgShow={true}
              cardDetail={CATEGORYCARD[11]}
            />
          )}
        {(showSafety || showSW) && ( //scorm mapping
          <Card
            iconShow={false}
            onClick={onClick}
            imgShow={true}
            cardDetail={CATEGORYCARD[12]}
          />
        )}
      </Grid>
    </>
  );
};

export default Utilitydashboard;
